export type EventCategory = {
  id: string;
  name: string;
  slug: string;
  icon: string;
  color: string;
  eventCount: number;
};

export type Organizer = {
  id: string;
  name: string;
  email: string;
  avatar: string;
  bio: string;
  status: 'active' | 'pending' | 'suspended';
  eventsCreated: number;
  totalRevenue: number;
  joinedAt: string;
  verified: boolean;
};

export type Event = {
  id: string;
  title: string;
  description: string;
  category: string;
  categoryId: string;
  organizerId: string;
  organizerName: string;
  date: string;
  time: string;
  endTime: string;
  location: string;
  venue: string;
  city: string;
  imageUrl: string;
  ticketPrice: number;
  vipPrice?: number;
  totalSeats: number;
  seatsRemaining: number;
  status: 'published' | 'draft' | 'cancelled' | 'completed' | 'pending';
  tags: string[];
  registrations: number;
  revenue: number;
};

export type Registration = {
  id: string;
  eventId: string;
  eventTitle: string;
  attendeeId: string;
  attendeeName: string;
  attendeeEmail: string;
  ticketType: 'general' | 'vip';
  quantity: number;
  totalPaid: number;
  status: 'confirmed' | 'cancelled' | 'refunded' | 'pending';
  registeredAt: string;
  seatNumbers: string[];
};

export type Ticket = {
  id: string;
  registrationId: string;
  eventId: string;
  eventTitle: string;
  eventDate: string;
  eventTime: string;
  venue: string;
  city: string;
  ticketType: 'general' | 'vip';
  seatNumber: string;
  price: number;
  status: 'confirmed' | 'cancelled' | 'used';
  qrCode: string;
  purchasedAt: string;
  organizerName: string;
  categoryName: string;
};

export const categories: EventCategory[] = [
{ id: 'cat-001', name: 'Conferences', slug: 'conferences', icon: 'Presentation', color: '#7C3AED', eventCount: 3 },
{ id: 'cat-002', name: 'Workshops', slug: 'workshops', icon: 'Wrench', color: '#2563EB', eventCount: 3 },
{ id: 'cat-003', name: 'Concerts', slug: 'concerts', icon: 'Music', color: '#DB2777', eventCount: 2 },
{ id: 'cat-004', name: 'Stand-up', slug: 'standup', icon: 'Mic2', color: '#D97706', eventCount: 2 },
{ id: 'cat-005', name: 'Networking', slug: 'networking', icon: 'Users', color: '#059669', eventCount: 2 }];


export const organizers: Organizer[] = [
{
  id: 'org-001',
  name: 'TechForward Events',
  email: 'hello@techforward.io',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_159efeaea-1779973445872.png",
  bio: 'Producing world-class tech conferences and developer workshops since 2018.',
  status: 'active',
  eventsCreated: 5,
  totalRevenue: 48200,
  joinedAt: '2024-03-12',
  verified: true
},
{
  id: 'org-002',
  name: 'Soundwave Productions',
  email: 'bookings@soundwave.com',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17041d62c-1785333923521.png",
  bio: 'Bringing the best live music experiences to venues across the country.',
  status: 'active',
  eventsCreated: 3,
  totalRevenue: 31500,
  joinedAt: '2024-06-01',
  verified: true
},
{
  id: 'org-003',
  name: 'Laugh Factory Live',
  email: 'shows@laughfactorylive.com',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1623c8473-1785764133659.png",
  bio: 'Curating top stand-up comedy nights and improv showcases nationwide.',
  status: 'active',
  eventsCreated: 2,
  totalRevenue: 8900,
  joinedAt: '2024-09-15',
  verified: false
},
{
  id: 'org-004',
  name: 'ConnectHub',
  email: 'events@connecthub.co',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1181b1e9e-1778228499224.png",
  bio: 'Facilitating meaningful professional networking events for founders and operators.',
  status: 'pending',
  eventsCreated: 2,
  totalRevenue: 4100,
  joinedAt: '2026-07-20',
  verified: false
}];


export const events: Event[] = [
{
  id: 'evt-001',
  title: 'React Summit 2026',
  description:
  'The largest React conference in North America returns for its 6th edition. Two days of deep-dive sessions on React 19, Server Components, the App Router, and the future of full-stack JavaScript. Featuring 30+ speakers from Meta, Vercel, and the open-source community.',
  category: 'Conferences',
  categoryId: 'cat-001',
  organizerId: 'org-001',
  organizerName: 'TechForward Events',
  date: '2026-09-12',
  time: '09:00',
  endTime: '18:00',
  location: 'Moscone Center, San Francisco, CA',
  venue: 'Moscone Center',
  city: 'San Francisco, CA',
  imageUrl: "https://images.unsplash.com/photo-1639527027808-7d178a943028",
  ticketPrice: 349,
  vipPrice: 699,
  totalSeats: 800,
  seatsRemaining: 142,
  status: 'published',
  tags: ['React', 'JavaScript', 'Frontend', 'Web Dev'],
  registrations: 658,
  revenue: 229642
},
{
  id: 'evt-002',
  title: 'AI Product Design Workshop',
  description:
  'A hands-on full-day workshop teaching product designers how to integrate AI tools into their workflow. Covers prompt engineering for design, using Midjourney and Figma AI, and building AI-augmented design systems.',
  category: 'Workshops',
  categoryId: 'cat-002',
  organizerId: 'org-001',
  organizerName: 'TechForward Events',
  date: '2026-08-22',
  time: '10:00',
  endTime: '17:00',
  location: 'WeWork SOMA, San Francisco, CA',
  venue: 'WeWork SOMA',
  city: 'San Francisco, CA',
  imageUrl: "https://images.unsplash.com/photo-1606982371677-a50ad8f38114",
  ticketPrice: 149,
  totalSeats: 60,
  seatsRemaining: 9,
  status: 'published',
  tags: ['AI', 'Design', 'Figma', 'Product'],
  registrations: 51,
  revenue: 7599
},
{
  id: 'evt-003',
  title: 'Indie Dev Meetup — August Edition',
  description:
  'Monthly networking event for independent developers, freelancers, and bootstrapped founders. Casual drinks, lightning talks (10 min each), and open floor for pitches and project showcases.',
  category: 'Networking',
  categoryId: 'cat-005',
  organizerId: 'org-001',
  organizerName: 'TechForward Events',
  date: '2026-08-14',
  time: '18:30',
  endTime: '21:30',
  location: 'The Creamery, San Francisco, CA',
  venue: 'The Creamery',
  city: 'San Francisco, CA',
  imageUrl: "https://images.unsplash.com/photo-1545052482-b125b110c084",
  ticketPrice: 15,
  totalSeats: 120,
  seatsRemaining: 34,
  status: 'published',
  tags: ['Indie', 'Networking', 'Developers', 'Startup'],
  registrations: 86,
  revenue: 1290
},
{
  id: 'evt-004',
  title: 'Neon Nights — Electronic Music Festival',
  description:
  'Three stages, 18 artists, one unforgettable night. Neon Nights brings together the best in house, techno, and ambient electronic music for a massive outdoor festival experience.',
  category: 'Concerts',
  categoryId: 'cat-003',
  organizerId: 'org-002',
  organizerName: 'Soundwave Productions',
  date: '2026-09-05',
  time: '20:00',
  endTime: '03:00',
  location: 'Shoreline Amphitheatre, Mountain View, CA',
  venue: 'Shoreline Amphitheatre',
  city: 'Mountain View, CA',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_15084e491-1782753942140.png",
  ticketPrice: 89,
  vipPrice: 199,
  totalSeats: 5000,
  seatsRemaining: 1203,
  status: 'published',
  tags: ['Electronic', 'Festival', 'Techno', 'House'],
  registrations: 3797,
  revenue: 337933
},
{
  id: 'evt-005',
  title: 'Open Mic Night — Comedy Showcase',
  description:
  'Eight up-and-coming comedians take the stage in an intimate 150-seat venue. Expect sharp observational humor, crowd work, and at least one bit about dating apps. 21+ event. Two-drink minimum.',
  category: 'Stand-up',
  categoryId: 'cat-004',
  organizerId: 'org-003',
  organizerName: 'Laugh Factory Live',
  date: '2026-08-09',
  time: '20:00',
  endTime: '22:30',
  location: 'The Punchline, San Francisco, CA',
  venue: 'The Punchline',
  city: 'San Francisco, CA',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea9a7088-1785764134787.png",
  ticketPrice: 28,
  totalSeats: 150,
  seatsRemaining: 22,
  status: 'published',
  tags: ['Comedy', 'Open Mic', '21+', 'Live'],
  registrations: 128,
  revenue: 3584
},
{
  id: 'evt-006',
  title: 'Kubernetes & Cloud Native Summit',
  description:
  'A full-day deep dive for platform engineers and DevOps practitioners covering Kubernetes 1.31, Helm chart best practices, GitOps workflows, and cost optimization strategies for cloud-native workloads.',
  category: 'Conferences',
  categoryId: 'cat-001',
  organizerId: 'org-001',
  organizerName: 'TechForward Events',
  date: '2026-10-03',
  time: '09:00',
  endTime: '17:30',
  location: 'Hyatt Regency, Austin, TX',
  venue: 'Hyatt Regency',
  city: 'Austin, TX',
  imageUrl: "https://images.unsplash.com/photo-1721125262809-cb3f455b94e9",
  ticketPrice: 299,
  vipPrice: 599,
  totalSeats: 400,
  seatsRemaining: 187,
  status: 'published',
  tags: ['Kubernetes', 'DevOps', 'Cloud', 'Platform Engineering'],
  registrations: 213,
  revenue: 63687
},
{
  id: 'evt-007',
  title: 'Watercolor Journaling Workshop',
  description:
  'A beginner-friendly 3-hour workshop covering loose watercolor techniques, composition basics, and how to build a daily journaling practice with mixed media. All materials included in ticket price.',
  category: 'Workshops',
  categoryId: 'cat-002',
  organizerId: 'org-004',
  organizerName: 'ConnectHub',
  date: '2026-08-30',
  time: '11:00',
  endTime: '14:00',
  location: 'Studio Bloom, Brooklyn, NY',
  venue: 'Studio Bloom',
  city: 'Brooklyn, NY',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_13248cbee-1785764134880.png",
  ticketPrice: 65,
  totalSeats: 24,
  seatsRemaining: 6,
  status: 'published',
  tags: ['Art', 'Watercolor', 'Creative', 'Beginner'],
  registrations: 18,
  revenue: 1170
},
{
  id: 'evt-008',
  title: 'Marcus Bell — Sold Out Tour Stop',
  description:
  'Grammy-nominated singer-songwriter Marcus Bell performs an intimate acoustic set from his critically acclaimed album "Quiet Hours." Limited seating — this show sold out in 4 hours.',
  category: 'Concerts',
  categoryId: 'cat-003',
  organizerId: 'org-002',
  organizerName: 'Soundwave Productions',
  date: '2026-07-18',
  time: '19:30',
  endTime: '22:00',
  location: 'The Fillmore, San Francisco, CA',
  venue: 'The Fillmore',
  city: 'San Francisco, CA',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_13287b3ae-1785764134675.png",
  ticketPrice: 75,
  vipPrice: 145,
  totalSeats: 600,
  seatsRemaining: 0,
  status: 'completed',
  tags: ['Acoustic', 'Singer-Songwriter', 'Intimate', 'Sold Out'],
  registrations: 600,
  revenue: 45000
},
{
  id: 'evt-009',
  title: 'Founders Dinner — SF Chapter',
  description:
  'An intimate seated dinner for 40 founders and operators. Curated table conversations, a keynote from a Series B founder, and structured 1:1 matching for collaboration opportunities.',
  category: 'Networking',
  categoryId: 'cat-005',
  organizerId: 'org-004',
  organizerName: 'ConnectHub',
  date: '2026-08-20',
  time: '19:00',
  endTime: '22:30',
  location: 'Bix Restaurant, San Francisco, CA',
  venue: 'Bix Restaurant',
  city: 'San Francisco, CA',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1c7ccf5d2-1785764134208.png",
  ticketPrice: 120,
  totalSeats: 40,
  seatsRemaining: 7,
  status: 'published',
  tags: ['Founders', 'Dinner', 'Networking', 'Startup'],
  registrations: 33,
  revenue: 3960
},
{
  id: 'evt-010',
  title: 'Tyler Ramos — Stand-Up Special Taping',
  description:
  'Comedy Central favorite Tyler Ramos is recording his next one-hour special live. Be part of the studio audience for a night of razor-sharp observational comedy and audience interaction.',
  category: 'Stand-up',
  categoryId: 'cat-004',
  organizerId: 'org-003',
  organizerName: 'Laugh Factory Live',
  date: '2026-07-25',
  time: '21:00',
  endTime: '22:30',
  location: 'Punch Line Comedy Club, Chicago, IL',
  venue: 'Punch Line Comedy Club',
  city: 'Chicago, IL',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_12b62aeea-1785764137784.png",
  ticketPrice: 45,
  totalSeats: 250,
  seatsRemaining: 0,
  status: 'completed',
  tags: ['Comedy', 'TV Special', 'Stand-up', 'Taping'],
  registrations: 250,
  revenue: 11250
},
{
  id: 'evt-011',
  title: 'Python for Data Science — Intensive',
  description:
  'A 2-day intensive workshop covering Python fundamentals, pandas, NumPy, matplotlib, and a capstone project building an end-to-end ML pipeline. Laptop required.',
  category: 'Workshops',
  categoryId: 'cat-002',
  organizerId: 'org-001',
  organizerName: 'TechForward Events',
  date: '2026-09-27',
  time: '09:00',
  endTime: '17:00',
  location: 'General Assembly, New York, NY',
  venue: 'General Assembly',
  city: 'New York, NY',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2922042-1785764135446.png",
  ticketPrice: 249,
  totalSeats: 40,
  seatsRemaining: 12,
  status: 'published',
  tags: ['Python', 'Data Science', 'ML', 'Intensive'],
  registrations: 28,
  revenue: 6972
},
{
  id: 'evt-012',
  title: 'Design Systems Conference 2026',
  description:
  'A one-day conference dedicated to design systems practitioners. Talks covering token architecture, component documentation, cross-team governance, and scaling design systems at enterprise.',
  category: 'Conferences',
  categoryId: 'cat-001',
  organizerId: 'org-001',
  organizerName: 'TechForward Events',
  date: '2026-11-07',
  time: '09:30',
  endTime: '18:00',
  location: 'The Venue, Chicago, IL',
  venue: 'The Venue',
  city: 'Chicago, IL',
  imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_13abc6eed-1776244366932.png",
  ticketPrice: 199,
  vipPrice: 399,
  totalSeats: 300,
  seatsRemaining: 218,
  status: 'published',
  tags: ['Design Systems', 'Tokens', 'Component Library', 'Enterprise'],
  registrations: 82,
  revenue: 16318
}];


export const registrations: Registration[] = [
{
  id: 'reg-001',
  eventId: 'evt-001',
  eventTitle: 'React Summit 2026',
  attendeeId: 'att-001',
  attendeeName: 'Priya Nair',
  attendeeEmail: 'priya.nair@outlook.com',
  ticketType: 'general',
  quantity: 1,
  totalPaid: 349,
  status: 'confirmed',
  registeredAt: '2026-07-15T10:23:00Z',
  seatNumbers: ['A-142']
},
{
  id: 'reg-002',
  eventId: 'evt-002',
  eventTitle: 'AI Product Design Workshop',
  attendeeId: 'att-001',
  attendeeName: 'Priya Nair',
  attendeeEmail: 'priya.nair@outlook.com',
  ticketType: 'general',
  quantity: 1,
  totalPaid: 149,
  status: 'confirmed',
  registeredAt: '2026-07-28T14:05:00Z',
  seatNumbers: ['B-08']
},
{
  id: 'reg-003',
  eventId: 'evt-008',
  eventTitle: 'Marcus Bell — Sold Out Tour Stop',
  attendeeId: 'att-001',
  attendeeName: 'Priya Nair',
  attendeeEmail: 'priya.nair@outlook.com',
  ticketType: 'vip',
  quantity: 2,
  totalPaid: 290,
  status: 'confirmed',
  registeredAt: '2026-06-10T09:00:00Z',
  seatNumbers: ['VIP-12', 'VIP-13']
},
{
  id: 'reg-004',
  eventId: 'evt-010',
  eventTitle: 'Tyler Ramos — Stand-Up Special Taping',
  attendeeId: 'att-001',
  attendeeName: 'Priya Nair',
  attendeeEmail: 'priya.nair@outlook.com',
  ticketType: 'general',
  quantity: 1,
  totalPaid: 45,
  status: 'confirmed',
  registeredAt: '2026-07-01T11:30:00Z',
  seatNumbers: ['C-88']
}];


export const myTickets: Ticket[] = [
{
  id: 'tkt-001',
  registrationId: 'reg-001',
  eventId: 'evt-001',
  eventTitle: 'React Summit 2026',
  eventDate: '2026-09-12',
  eventTime: '09:00',
  venue: 'Moscone Center',
  city: 'San Francisco, CA',
  ticketType: 'general',
  seatNumber: 'A-142',
  price: 349,
  status: 'confirmed',
  qrCode: 'QR-EVT001-A142',
  purchasedAt: '2026-07-15T10:23:00Z',
  organizerName: 'TechForward Events',
  categoryName: 'Conferences'
},
{
  id: 'tkt-002',
  registrationId: 'reg-002',
  eventId: 'evt-002',
  eventTitle: 'AI Product Design Workshop',
  eventDate: '2026-08-22',
  eventTime: '10:00',
  venue: 'WeWork SOMA',
  city: 'San Francisco, CA',
  ticketType: 'general',
  seatNumber: 'B-08',
  price: 149,
  status: 'confirmed',
  qrCode: 'QR-EVT002-B08',
  purchasedAt: '2026-07-28T14:05:00Z',
  organizerName: 'TechForward Events',
  categoryName: 'Workshops'
},
{
  id: 'tkt-003',
  registrationId: 'reg-003',
  eventId: 'evt-008',
  eventTitle: 'Marcus Bell — Sold Out Tour Stop',
  eventDate: '2026-07-18',
  eventTime: '19:30',
  venue: 'The Fillmore',
  city: 'San Francisco, CA',
  ticketType: 'vip',
  seatNumber: 'VIP-12',
  price: 145,
  status: 'used',
  qrCode: 'QR-EVT008-VIP12',
  purchasedAt: '2026-06-10T09:00:00Z',
  organizerName: 'Soundwave Productions',
  categoryName: 'Concerts'
},
{
  id: 'tkt-004',
  registrationId: 'reg-004',
  eventId: 'evt-010',
  eventTitle: 'Tyler Ramos — Stand-Up Special Taping',
  eventDate: '2026-07-25',
  eventTime: '21:00',
  venue: 'Punch Line Comedy Club',
  city: 'Chicago, IL',
  ticketType: 'general',
  seatNumber: 'C-88',
  price: 45,
  status: 'used',
  qrCode: 'QR-EVT010-C88',
  purchasedAt: '2026-07-01T11:30:00Z',
  organizerName: 'Laugh Factory Live',
  categoryName: 'Stand-up'
}];


export const weeklySalesData = [
{ week: 'Jun 16', tickets: 142, revenue: 18640 },
{ week: 'Jun 23', tickets: 198, revenue: 24750 },
{ week: 'Jun 30', tickets: 167, revenue: 21080 },
{ week: 'Jul 7', tickets: 234, revenue: 31220 },
{ week: 'Jul 14', tickets: 189, revenue: 25110 },
{ week: 'Jul 21', tickets: 312, revenue: 41580 },
{ week: 'Jul 28', tickets: 278, revenue: 37040 },
{ week: 'Aug 4', tickets: 203, revenue: 27040 }];


export const revenueByCategory = [
{ category: 'Conferences', revenue: 309647 },
{ category: 'Concerts', revenue: 382933 },
{ category: 'Workshops', revenue: 15741 },
{ category: 'Stand-up', revenue: 14834 },
{ category: 'Networking', revenue: 5250 }];


export const platformMetrics = {
  totalRevenue: 728405,
  totalTicketsSold: 5944,
  eventsLive: 9,
  organizersActive: 3,
  pendingApprovals: 1,
  cancellationRate: 3.2,
  avgTicketPrice: 122.5,
  revenueGrowth: 18.4
};

export const notifications = [
{
  id: 'notif-001',
  type: 'update',
  title: 'Event time updated',
  message: 'React Summit 2026 doors now open at 08:30 AM instead of 09:00 AM.',
  eventId: 'evt-001',
  createdAt: '2026-08-01T09:00:00Z',
  read: false
},
{
  id: 'notif-002',
  type: 'alert',
  title: 'Low seats remaining',
  message: 'AI Product Design Workshop has only 9 seats left. Your spot is confirmed.',
  eventId: 'evt-002',
  createdAt: '2026-07-30T14:30:00Z',
  read: false
},
{
  id: 'notif-003',
  type: 'success',
  title: 'Ticket confirmed',
  message: 'Your ticket for React Summit 2026 (Seat A-142) has been confirmed.',
  eventId: 'evt-001',
  createdAt: '2026-07-15T10:25:00Z',
  read: true
},
{
  id: 'notif-004',
  type: 'info',
  title: 'New event from TechForward',
  message: 'Design Systems Conference 2026 is now open for registration.',
  eventId: 'evt-012',
  createdAt: '2026-07-10T08:00:00Z',
  read: true
}];